const apiUrl = process.env.REACT_APP_API_URL;

export const GetAulesIdConfiguracio = async (id: string, ra: number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id}/configuracio?ra=${ra}`);
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
